import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NgbTimeAdapter, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoModule } from '@ngneat/transloco';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ColorPickerComponent } from 'ngx-color-picker';
import { DndModule } from 'ngx-drag-drop';
import { ComponentsModule } from '../components/components.module';
import { NgbTimeStringAdapter } from '../config/app.config';
import { DatabaseTableViewComponent } from './database-table-view/database-table-view.component';
import { SingleDatabaseTableViewComponent } from './database-table-view/single-database-table-view/single-database-table-view.component';
import { DtypeComponentListComponent } from './dtype-component-list/dtype-component-list.component';
import { DtypeDetailsComponent } from './dtype-details/dtype-details.component';
import { DtypeEditorPreviewComponent } from './dtype-editor-preview/dtype-editor-preview.component';
import { DTypeFacadeListComponent } from './dtype-facade-list/dtype-facade-list.component';
import { DtypeConditionDialogComponent } from './dtype-field-edit/dtype-condition/dtype-condition.dialog';
import { DtypeFieldEditDialogComponent } from './dtype-field-edit/dtype-field-edit.dialog';
import { DtypeFieldlistComponent } from './dtype-fieldlist/dtype-fieldlist.component';
import { DtypeFieldtypelistComponent } from './dtype-fieldtypelist/dtype-fieldtypelist.component';
import { DtypeItemComponent } from './dtype-item/dtype-item.component';
import { DtypeListConfigComponent } from './dtype-list-config/dtype-list-config.component';
import { DTypeMigrationComponent } from './dtype-migration/dtype-migration.component';
import { DtypePreviewTableComponent } from './dtype-preview-table/dtype-preview-table.component';
import { DTypeQuarantineTableComponent } from './dtype-quarantine/dtype-quarantine-table/dtype-quarantine-table.component';
import { DTypeQuarantineComponent } from './dtype-quarantine/dtype-quarantine.component';
import { DtypeDirective } from './dtype.directive';
import { DTypeAddressAssistantFieldComponent } from './fields/address-field/address-assistant-field/address-assistant-field.component';
import { DTypeAddressFieldComponent } from './fields/address-field/address-field.component';
import { DtypeAutocompleteFieldComponent } from './fields/autocomplete-field/autocomplete-field.component';
import { DtypeCategorySelectFieldComponent } from './fields/categoryselect-field/category-select-field.component';
import { DtypeCheckboxFieldComponent } from './fields/checkbox-field/checkbox-field.component';
import { DtypeChiplistFieldComponent } from './fields/chiplist-field/chiplist-field.component';
import { DtypeCodebarScannerFieldComponent } from './fields/codebar-scanner-field/codebar-scanner-field.component';
import { DtypeCollectionFieldComponent } from './fields/collection-field/collection-field.component';
import { DtypeColorFieldComponent } from './fields/color-field/color-field.component';
import { DtypeComplexMaskFieldComponent } from './fields/complex-mask-field/complex-mask-field.component';
import { DtypeComplexTotalFieldComponent } from './fields/complex-total-field/complex-total-field.component';
import { DtypeComplexUniqueIndexFieldComponent } from './fields/complex-unique-index-field/complex-unique-index-field.component';
import { DtypeDatepickerFieldComponent } from './fields/datepicker-field/datepicker-field.component';
import { DtypeDaterangepickerFieldComponent } from './fields/daterangepicker-field/daterangepicker-field.component';
import { DtypeDatetimepickerFieldComponent } from './fields/datetimepicker-field/datetimepicker-field.component';
import { DtypeFieldChiplistFieldComponent } from './fields/field-chiplist-field/field-chiplist-field.component';
import { DtypeFileFieldComponent } from './fields/file-field/file-field.component';
import { DtypeFreetextFieldComponent } from './fields/freetext-field/freetext-field.component';
import { DtypeIconFieldComponent } from './fields/icon-field/icon-field.component';
import { DtypeImageFieldComponent } from './fields/image-field/image-field.component';
import { DtypeItemFieldComponent } from './fields/item-field/item-field.component';
import { DtypeMultiImageFieldComponent } from './fields/multiimage-field/multiimage-field.component';
import { DtypeNumberFieldComponent } from './fields/number-field/number-field.component';
import { DtypeRadioFieldComponent } from './fields/radio-field/radio-field.component';
import { DtypeRatingFieldComponent } from './fields/rating-field/rating-field.component';
import { DtypeRatingLinkedToTableFieldComponent } from './fields/rating-linked-to-table-field/rating-linked-to-table-field.component';
import { DtypeSelectFieldComponent } from './fields/select-field/select-field.component';
import { DtypeSelectGroupFieldComponent } from './fields/select-group-field/select-group-field.component';
import { DtypeSignatureFieldComponent } from './fields/signature-field/signature-field.component';
import { DtypeSmileysFieldComponent } from './fields/smileys-field/smileys-field.component';
import { DtypeSummaryMaskFieldComponent } from './fields/summary-mask-field/summary-mask-field.component';
import { DtypeTableWithFixedRowsComponent } from './fields/table-field/components/tablewithfixedrows/tablewithfixedrows.component';
import { DtypeTableWithVariableRowsComponent } from './fields/table-field/components/tablewithvariablerows/tablewithvariablerows.component';
import { DtypeTableFieldComponent } from './fields/table-field/table-field.component';
import { TableRowDialogComponent } from './fields/table-field/table-row.dialog.component';
import { DtypeTableWithRatingLinkedComponent } from './fields/table-with-rating-linked-field/table-with-rating-linked-field.component';
import { DtypeTableWithFixedRowsFieldComponent } from './fields/tablewithfixedrows-field/tablewithfixedrows-field.component';
import { DtypeTableWithVariableRowsFieldComponent } from './fields/tablewithvariablerows-field/tablewithvariablerows-field.component';
import { DtypeTextFieldComponent } from './fields/text-field/text-field.component';
import { DtypeTextMaskFieldComponent } from './fields/text-mask-field/text-mask-field.component';
import { DtypeTimepickerFieldComponent } from './fields/timepicker-field/timepicker-field.component';
import { DtypeTimeRangesConverterFieldComponent } from './fields/timerangesconverter-field/timerangesconverter-field.component';
import { DtypeTristateFieldComponent } from './fields/tristate-field/tristate-field.component';
import { DtypeTwoColumnsTableFieldComponent } from './fields/two-columns-table/twocolumnstable-field.component';
import { DtypeUserProfileChiplistFieldComponent } from './fields/user-profile-chiplist-field/user-profile-chiplist-field.component';
import { DtypeUserSelectFieldComponent } from './fields/user-select-field/user-select-field.component';
import { DtypeWYSIWYGFieldComponent } from './fields/wysiwyg-field/wysiwyg-field.component';
import { SingleGeopositionMapComponent } from '../components/geoposition-map/single-geoposition-map/single-geoposition-map.component';
import { GeopositionMapComponent } from '../components/geoposition-map/geoposition-map.component';
import { SharedModule } from '../../shared/shared.module';
import { FuseCardModule } from '../../../@fuse/components/card/card.module';
import { FuseScrollbarModule } from '../../../@fuse/directives/scrollbar/scrollbar.module';
import { DtypeWeekDaysFieldComponent } from './fields/weekdays-field/weekdays-field.component';

@NgModule({
    declarations: [
        DatabaseTableViewComponent,
        SingleDatabaseTableViewComponent,
        DTypeQuarantineComponent,
        DTypeQuarantineTableComponent,
        DTypeAddressFieldComponent,
        DTypeAddressAssistantFieldComponent,
        DtypeAutocompleteFieldComponent,
        DtypeCategorySelectFieldComponent,
        DtypeCheckboxFieldComponent,
        DtypeChiplistFieldComponent,
        DtypeCodebarScannerFieldComponent,
        DtypeCollectionFieldComponent,
        DtypeColorFieldComponent,
        DtypeComplexMaskFieldComponent,
        DtypeComplexUniqueIndexFieldComponent,
        DtypeComplexTotalFieldComponent,
        DtypeComponentListComponent,
        DtypeConditionDialogComponent,
        DtypeDatepickerFieldComponent,
        DtypeDaterangepickerFieldComponent,
        DtypeDatetimepickerFieldComponent,
        DtypeDetailsComponent,
        DtypeDirective,
        DtypeEditorPreviewComponent,
        DTypeFacadeListComponent,
        DtypeFieldChiplistFieldComponent,
        DtypeFieldEditDialogComponent,
        DtypeFieldlistComponent,
        DTypeMigrationComponent,
        DtypeFieldtypelistComponent,
        DtypeFileFieldComponent,
        DtypeFreetextFieldComponent,
        DtypeIconFieldComponent,
        DtypeImageFieldComponent,
        DtypeItemComponent,
        DtypeItemFieldComponent,
        DtypeListConfigComponent,
        DtypeMultiImageFieldComponent,
        DtypeNumberFieldComponent,
        DtypePreviewTableComponent,
        DtypeRadioFieldComponent,
        DtypeSelectFieldComponent,
        DtypeSelectGroupFieldComponent,
        DtypeSignatureFieldComponent,
        DtypeSummaryMaskFieldComponent,
        DtypeTableFieldComponent,
        DtypeTableWithFixedRowsFieldComponent,
        DtypeTableWithFixedRowsComponent,
        DtypeTableWithRatingLinkedComponent,
        DtypeTableWithVariableRowsFieldComponent,
        DtypeTableWithVariableRowsComponent,
        DtypeTextFieldComponent,
        DtypeTextMaskFieldComponent,
        DtypeTimepickerFieldComponent,
        DtypeTimeRangesConverterFieldComponent,
        DtypeTristateFieldComponent,
        DtypeTwoColumnsTableFieldComponent,
        DtypeUserProfileChiplistFieldComponent,
        DtypeUserSelectFieldComponent,
        DtypeWYSIWYGFieldComponent,
        DtypeRatingFieldComponent,
        DtypeRatingLinkedToTableFieldComponent,
        DtypeSmileysFieldComponent,
        TableRowDialogComponent
    ],
    imports: [
        ComponentsModule,
        ColorPickerComponent,
        DndModule,
        EditorModule,
        FuseCardModule,
        FuseScrollbarModule,
        NgbTimepickerModule,
        RouterModule,
        SharedModule,
        TranslocoModule,
        MatIconModule,
        GeopositionMapComponent,
        SingleGeopositionMapComponent,
        DtypeWeekDaysFieldComponent
    ],
    exports: [
        DatabaseTableViewComponent,
        SingleDatabaseTableViewComponent,
        DTypeQuarantineComponent,
        DTypeQuarantineTableComponent,
        DtypeComponentListComponent,
        DtypeDetailsComponent,
        DtypeEditorPreviewComponent,
        DTypeFacadeListComponent,
        DtypeFieldlistComponent,
        DTypeMigrationComponent,
        DtypeItemComponent,
        DtypeListConfigComponent,
        DtypePreviewTableComponent,
        MatIconModule,
        // MatIconRegistry
    ],
    providers: [
        { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter },
        // MatIconRegistry
    ]
})
export class DTypeModule { }
